import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/phone.png'
import _imports_1 from '@/assets/images/email.png'
import _imports_2 from '@/assets/images/address.png'


const _withScopeId = n => (_pushScopeId("data-v-50a5a3d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-info" }
const _hoisted_2 = { class: "address-img" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "detail" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Map)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.state.companyInfo.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, " 电话：" + _toDisplayString(_ctx.state.companyInfo.mobile), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, " 邮箱：" + _toDisplayString(_ctx.state.companyInfo.email), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, " 地址：" + _toDisplayString(_ctx.state.companyInfo.address), 1)
      ])
    ])
  ]))
}